export enum LatestNewsCategory {
  CONTENT = 'content',
  MAIN = 'main'
}